module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper pt-header65"
  }, [_c('header', {
    staticClass: "gheader -white gheader-fix"
  }, [_c('div', {
    staticClass: "gheader__link-back"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.backHome
    }
  }, [_vm._v("戻る")])])]), _c('div', {
    staticClass: "container stepup-uncheck bg04"
  }, [_c('div', {
    staticClass: "row inner"
  }, [_c('div', {
    staticClass: "user-post-detail__body__others bg05"
  }, _vm._l((_vm.serviceNoAnswers), function(serviceAnswer, index) {
    return (_vm.serviceNoAnswers) ? _c('div', [_c('div', {
      staticClass: "user-outline"
    }, [(serviceAnswer['profile_image_path']) ? _c('div', {
      staticClass: "user-outline__img"
    }, [_c('img', {
      attrs: {
        "src": serviceAnswer['profile_image_path'] + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
      }
    })]) : _c('div', {
      staticClass: "user-outline__img"
    }, [_c('img', {
      attrs: {
        "src": require("./images/img_profile.png"),
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "user-outline__body"
    }, [_c('p', {
      staticClass: "user-outline__body__role fz11"
    }, [_vm._v(_vm._s(serviceAnswer['shop_name']) + " " + _vm._s(serviceAnswer['user_type_name']))]), _c('h3', {
      staticClass: "user-outline__body__name fz16"
    }, [_vm._v(_vm._s(serviceAnswer['user_name']))])])])]) : _vm._e()
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5e98be7c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ServiceAnswerCallList.vue
// module id = 1401
// module chunks = 1